import {NgModule} from '@angular/core';
import {DataGridsModule} from './data-grids/data-grids.module';

@NgModule({
    exports:[
        DataGridsModule
    ],
    imports: [
        DataGridsModule
    ]
})
export class DataModule {
}
